import { registerStores } from 'lib/exp/flux';

import asset from 'stores/shared/asset';
import bookable_template from 'stores/shared/bookable_template';
import booking from 'stores/shared/booking';
import booking_slot from 'stores/shared/booking_slot';
import calendar from 'stores/shared/calendar';
import cancellation_policy from 'stores/shared/cancellation_policy';
import currency from 'stores/shared/currency';
import custom_booking from 'stores/shared/custom_booking';
import device from 'stores/shared/device';
import guest from 'stores/shared/guest';
import guide_pricing from 'stores/shared/pricing';
import languages from 'stores/shared/languages';
import session from 'stores/anyguide/session';
import slide_up_menu from 'stores/shared/slide_up_menu';
import tour from 'stores/shared/tour';
import user from 'stores/shared/user';
import user_overview from 'stores/shared/user_overview';

function getInitialState() {
  try {
    const stateTreeTag = document.getElementById('state_tree');
    return JSON.parse(stateTreeTag.text);
  } catch (e) {
    return {};
  }
}

export default function init() {
  registerStores(
    {
      asset,
      bookable_template,
      booking,
      booking_slot,
      calendar,
      cancellation_policy,
      currency,
      custom_booking,
      device,
      guest,
      guide_pricing,
      languages,
      session,
      slide_up_menu,
      tour,
      user,
      user_overview,
    },
    getInitialState()
  );
}
